import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { getBanners } from "../../redux/Slice/carSlice";
import "swiper/css";
// import 'swiper/css/pagination';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Fragment } from "react";

function SimpleSlider() {
  const dispatch = useDispatch();
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const getBannerData = useSelector((state) => state?.car?.getBannerData?.data);

  useEffect(() => {
    dispatch(getBanners());
  }, []);

  // const progressCircle = useRef(null);
  // const progressContent = useRef(null);
  // const onAutoplayTimeLeft = (s, time, progress) => {
  //   progressCircle.current.style.setProperty('--progress', 1 - progress);
  //   progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  // };

  // const settings = {
  //     dots: true,
  //     infinite: true,
  //     autoplay: true,
  //     speed: 500,
  //     slidesToShow: 2,
  //     slidesToScroll: 1,
  //     autoplaySpeed: 2000,
  //     centerPadding: '50px',

  // };
  return (
    <div className="slider-container  container mx-auto my-6">
      {/* <Slider {...settings}>
                {getBannerData?.map((data) => {
                    return (
                                                <div className="banner-container border border-gray-500 rounded">
                            <div className="image-container">
                                <img src={`${baseURL}${data?.image}`} alt="Promotional content" className="img-fluid h200 rounded-2" />
                            </div>
                            <div className="bg-banner">
                                <div className="text-container pt-2 md:flex justify-center items-center flex-col">
                                    <p className="text-center my-1 text-xl md:text-2xl">{data?.dealText}</p>
                                    <p className="font-bold text-center mb-2 md:text-xl">{data?.discountAmount}</p>
                                </div>
                            </div>
                        </div>



                        
                    );
                })}
            </Slider> */}

      {/* <Swiper
                slidesPerView={2}
                spaceBetween={30}
                autoplay={{ delay: 3000 }}
                pagination={{
                    clickable: true,
                }}
                className="mySwiper"
                breakpoints={{
                    767: {
                        slidesPerView: 1,
                    },
                  
                }}
            > */}
      <Swiper
        spaceBetween={30}
        slidesPerView={2}
        // centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        // onAutoplayTimeLeft={onAutoplayTimeLeft}
        className="mySwiper"
        breakpoints={{
          200: {
            slidesPerView: 1, // Show 1 slide on screens >= 320px
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2, // Show 2 slides on screens >= 768px
            spaceBetween: 30,
          },
        }}
      >
        {getBannerData?.map((data, index) => {
          return (
            <SwiperSlide key={data?._id}>
              <div className="bg-banner d-flex flex-col md:flex-row gap-auto md:justify-between xl:gap-x-24 border border-gray-500 rounded">
                <div className="align-items-center d-flex flex-column justify-content-center p-2 width40">
                  <p className="text-center my-1 text-xl md:text-2xl text-white">
                    {data?.dealText}
                  </p>
                  <p className="font-bold text-center mb-2 md:text-xl text-white">
                    {data?.discountAmount}
                  </p>
                </div>
                <div className="p-2 width60">
                  <img
                    src={`${baseURL}${data?.image}`}
                    alt="Promotional content"
                    className="img-fluid h200 rounded-2 img-banner-set"
                  />
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default SimpleSlider;
